import * as React from "react";
import { useFormField } from "./use-form-field";

export const FormDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ ...props }, ref) => {
  const { formDescriptionId } = useFormField();

  return <p ref={ref} id={formDescriptionId} {...props} />;
});
FormDescription.displayName = "FormDescription";
